import React, { memo, useState } from 'react';
import { ActiveVisitor, Client, UniqueVisitor } from 'types';
import { getVisitorDisplayName } from 'shared/utils/visitor';
import EmptyAvatar from '../EmptyAvatar';
import './style.less';

interface VisitorAvatarProps {
  visitor: Client | ActiveVisitor | UniqueVisitor | null;
  revealAvatar?: string;
  size: number;
}

export const VisitorAvatar: React.FC<VisitorAvatarProps> = memo(
  ({ visitor, size, revealAvatar }) => {
    const [hasRevealAvatarError, setHasRevealAvatarErrorError] = useState<boolean>(false);

    if (!visitor) {
      return (
        <div
          className="VisitorAvatar"
          style={{ width: size, minWidth: size, height: size }}
        >
          <EmptyAvatar id={0} name="-" size={size} />
        </div>
      );
    }

    if (revealAvatar && !hasRevealAvatarError) {
      return (
        <div className="VisitorAvatar">
          <img
            className="VisitorAvatar__reveal"
            alt={getVisitorDisplayName(visitor)}
            src={revealAvatar}
            width={size}
            height={size}
            onError={() => setHasRevealAvatarErrorError(true)}
          />
        </div>
      );
    }

    if (typeof visitor?.customMetadata?.avatar === 'string') {
      return (
        <div className="VisitorAvatar">
          <img
            alt={getVisitorDisplayName(visitor)}
            src={visitor?.customMetadata?.avatar}
            width={size}
            height={size}
          />
        </div>
      );
    }

    const visitorDisplayName = getVisitorDisplayName(visitor);
    const name =
      !visitorDisplayName || visitorDisplayName === 'Unknown' ? '-' : visitorDisplayName;

    // UniqueVisitor
    if ('id' in visitor) {
      return (
        <div
          className="VisitorAvatar"
          style={{ width: size, minWidth: size, height: size }}
        >
          <EmptyAvatar id={visitor.id} name={name} size={size} />
        </div>
      );
    }

    return (
      <div
        className="VisitorAvatar"
        style={{ width: size, minWidth: size, height: size }}
      >
        <EmptyAvatar id={visitor.sbid} name={name} size={size} />
      </div>
    );
  },
);
